import React, { useState } from 'react';
import { Tabs, Tab } from '@material-ui/core';

import { Title } from '~/components/Title';
import { Divider } from '../MapOpportunities/styles';
import VehicleSearch from './components/VehicleSearch';
import AssociadoSearch from './components/AssociadoSearch';
import Listings from './components/Listings';
import ProductSearch from './components/ProductSearch';

enum HinovaTab {
  VEHICLES = 0,
  ASSOCIADOS = 1,
  PRODUCTS = 2,
  LISTINGS = 3,
}

export default function Hinova() {
  const [activeTab, setActiveTab] = useState<HinovaTab>(HinovaTab.VEHICLES);

  return (
    <div>
      <Title>Gerenciamento SGA</Title>
      <Divider height={20} />

      <Tabs
        value={activeTab}
        onChange={(_, newValue) => {
          setActiveTab(newValue);
        }}
        indicatorColor='primary'
        textColor='primary'
        style={{
          marginBottom: 25,
        }}
      >
        <Tab label='Pesquisar Placa' />
        <Tab label='Pesquisar CPF' />
        <Tab label='Pesquisar Produto' />
        <Tab label='Regional/Cooperativa' />
      </Tabs>

      {activeTab === HinovaTab.VEHICLES && <VehicleSearch />}
      {activeTab === HinovaTab.ASSOCIADOS && <AssociadoSearch />}
      {activeTab === HinovaTab.PRODUCTS && <ProductSearch />}
      {activeTab === HinovaTab.LISTINGS && <Listings />}
    </div>
  );
}
